<template slot-scope="props">
  <div class="animated fadeIn">
    <form @submit.stop.prevent="post()">
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
            
            <div slot="header" class="d-flex align-items-center justify-content-between" :class="isDark ? 'bg-dark border-secondary' : ''">
                <div>
                  <i class='fa fa-file-text-o mr-2'></i><strong>Relatório de Contas Recebidas</strong>
                </div>
            </div>

            <!-- Seção 1: Filtros Principais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-users mr-2"></i>Filtros Principais</h6>
              <b-row>
                <b-col md="12">
                  <b-form-group label="Cliente">
                    <cliente-pesquisa 
                      @retornaId="registro.CLIENTE_ID = $event"
                      :idInicial="registro.CLIENTE_ID"
                      :classe-required="CLIENTE_IDRequerido()"
                      place="Todos os clientes"
                      ref="clientepesquisa"
                      idModal="clientepesquisa"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Vendedor">
                    <vendedor-dropdown 
                      v-model="registro.VENDEDOR_ID"
                      :classe-required="VENDEDOR_IDRequerido()"
                      ref="vendedorpesquisa"
                      placeholder="Todos os vendedores"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Grupo">
                    <grupo-areceber-drop-down
                      v-model="registro.GRUPO_ID"
                      :classe-required="GRUPO_IDRequerido()"
                      ref="grupopesquisa"
                      placeholder="Todos os grupos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Período -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-calendar mr-2"></i>Período</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Início">
                    <cec-input-data id="dt1" v-model="registro.DT1" :state="registro.DT1 ? null : false" />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Data Fim">
                    <cec-input-data id="dt2" v-model="registro.DT2" :state="registro.DT2 ? null : false" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Configurações -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Configurações</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label="Tipo de Relatório">
                    <b-form-select :plain="true" v-model="selected" :options="options" :class="isDark ? 'bg-secondary text-white border-info' : ''" />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div slot="footer" class="p-3" :class="isDark ? 'bg-dark border-top border-secondary' : 'bg-light'">
              <b-row class="justify-content-center">
                <b-col md="4" sm="12">
                  <vue-button-spinner block size="lg" type="submit" variant="primary" :isLoading="isLoading" :disabled="isLoading" :status="status" class="btn-generate shadow-sm">
                    <i class="fa fa-file-pdf-o mr-2"></i> GERAR RELATÓRIO
                  </vue-button-spinner>              
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import VendedorDropdown from '../componentes/dropdown/VendedorDropdown.vue'
import ClientePesquisa from '../pesquisa/ClientePesquisa.vue'
import GrupoAreceberDropDown from '../componentes/dropdown/GrupoAreceberDropDown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'

export default {
  data () {
    return {
      registro: {
        CLIENTE_ID: null,
        VENDEDOR_ID: null,
        GRUPO_ID: null,
        DT1: moment().format('YYYY-MM-DD'),
        DT2: moment().format('YYYY-MM-DD')
      },
      parametros: {
        nomeCliente: '',
        nomeVendedor: '',
        nomeGrupo: ''
      },
      isLoading: false,
      status: '',
      submmited: false,
      selected: 'S',
      options: [
        { text: 'Analítico por Cliente', value: 'A' },
        { text: 'Sintético', value: 'S' },
        { text: 'Analítico por Data', value: 'D' },
        { text: 'Acumulado por Cliente', value: 'T' }
      ]
    }
  },
  components: {
    VueButtonSpinner,
    VendedorDropdown,
    ClientePesquisa,
    GrupoAreceberDropDown,
    CecInputData
  },
  computed: {
    isValid () {
      return !!this.registro.DT1 && !!this.registro.DT2
    },
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    }
  },
  methods: {
    CLIENTE_IDRequerido () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return !!this.registro.CLIENTE_ID
      } else {
        return true
      }
    },
    VENDEDOR_IDRequerido () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return !!this.registro.VENDEDOR_ID
      } else {
        return true
      }
    },
    GRUPO_IDRequerido () {
      if ((this.selected === '1') || (this.selected === '2')) {
        return !!this.registro.GRUPO_ID
      } else {
        return true
      }
    },
    async post () {
      if (!this.isValid) {
        Tools.exibirMensagem(this.$store, 'Por favor, preencha todos os campos obrigatórios', 'warning', 'Aviso')
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true
      this.submmited = true

      const params = {
        clienteid: this.registro.CLIENTE_ID || '',
        lbempresa: window.localStorage.getItem('nomeempresa'),
        grupoid: this.registro.GRUPO_ID || '',
        dt1: this.registro.DT1,
        dt2: this.registro.DT2,
        lbcliente: this.$refs.clientepesquisa?.$refs?.auto?.display || '',
        lbvendedor: this.getLabelFromDropDown('vendedorpesquisa', this.registro.VENDEDOR_ID),
        lbgrupo: this.getLabelFromDropDown('grupopesquisa', this.registro.GRUPO_ID),
        lbusuario: window.localStorage.getItem('nomeusuario'),
        tiporel: this.selected
      }

      const uri = '/api/protected/relatorios/recebido/relrecebido?' + new URLSearchParams(params).toString()

      try {
        const response = await this.$http.get(uri, { responseType: 'arraybuffer' })
        Tools.exibirMensagem(this.$store, 'Relatório Gerado com Sucesso', 'success', 'Sucesso')
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        window.open(url)
      } catch (erro) {
        Tools.exibirMensagem(this.$store, 'Ocorreu uma falha ao gerar o relatório!!!', 'danger', 'Aviso')
      } finally {
        this.isLoading = false
        this.submmited = false
        this.$store.commit('controle/setAguardando', false)
      }
    },
    getLabelFromDropDown (refName, value) {
      if (!value) return ''
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    }
  },
  watch: {
    'registro.CLIENTE_ID': function () {
      this.CLIENTE_IDRequerido()
    },
    'registro.VENDEDOR_ID': function () {
      this.VENDEDOR_IDRequerido()
    },
    'registro.GRUPO_ID': function () {
      this.GRUPO_IDRequerido()
    }
  }
}
</script>

<style scoped>
.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e4e7ea;
  transition: all 0.3s ease;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.section-container.dark-mode {
  background: #2f353a;
  border-color: #434a50;
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #434a50;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  padding: 12px;
  transition: all 0.3s;
}

.btn-generate:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(32, 168, 216, 0.4);
}

.dark-mode .form-group label {
  color: #a4b7c1;
}

#card-relatorio {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelRecebido.vue